import React, { useEffect, useRef, useState } from "react";
import OrdersListView from "@screens/OrdersList/View";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import t from "@constants/localization";
import { getAllOrders } from "../../../services/api";

const PATH = "screens/CustomerProfile/UsersOrderList";

const DailyOrderList = ({ navigation, route }) => {
  const [orders, setOrders] = useState([]);
  const [isFetchingOrders, setIsFetchingOrders] = useState(true);
  const [canFetchOrders, setCanFetchOrders] = useState(true);
  const offset = useRef(0);
  const limit = useRef(10);
  const totalOrders = useRef(0);

  useEffect(() => {
    fetchCustomerOrders(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCustomerOrders = (firstCall = false) => {
    setCanFetchOrders(orders.length >= totalOrders.current);
    if (!firstCall && orders.length >= totalOrders.current) {
      return;
    }
    if (Array.isArray(orders) && orders.length < totalOrders.current) {
      offset.current = firstCall
        ? offset.current
        : offset.current + limit.current;
    }
    const payload = {
      offset: 0,
      limit: 100,
      userId: route?.params?.user_id,
      date: route?.params?.date,
      type: route?.params?.type,
    };
    getAllOrders(payload)
      .then(({ data }) => {
        totalOrders.current = data.count;
        setOrders(orders.concat(data.orders));
        setIsFetchingOrders(false);
      })
      .catch((e) => {
        console.log(e);
        setIsFetchingOrders(false);
      });
  };
  return (
    <>
      <HeaderWithBackAndTitle
        headertitle={`${route?.params?.user_name} जी की`}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        subHeaderTitle="आज की डिलीवरी"
      />
      <OrdersListView
        isProfileShow={true}
        waText={t(`${PATH}/shareBill`)}
        orders={orders}
        fetchCommunityLeaderOrders={fetchCustomerOrders}
        loading={isFetchingOrders}
        canFetchOrders={canFetchOrders}
        userId={route?.params?.user_id}
        eventProps={route?.params?.eventProps}
      />
    </>
  );
};

export default DailyOrderList;
